import { useAtomCallback } from "jotai/utils";
import { activeConversationSidAtom } from "../state";
import { useCallback } from "react";
import { unreadMessagesCountFamily } from "../../session/state";
import { setFaviconAndTitleBasedOnUnreadMessagesCount } from "../chat/utils";

import { useTranslate } from "@growtherapy/i18n";

export function useResetFaviconAndTitleCallback() {
  const t = useTranslate();
  const getActiveConversationSid = useAtomCallback(
    useCallback((get) => get(activeConversationSidAtom), []),
  );
  const getUnreadMessagesCount = useAtomCallback(
    useCallback(
      (get, _set, activeConversationSid?: string) =>
        get(unreadMessagesCountFamily(activeConversationSid ?? "")),
      [],
    ),
  );

  return useCallback(() => {
    const activeConversationSid = getActiveConversationSid();
    const unreadMessagesCount = getUnreadMessagesCount(activeConversationSid);
    setFaviconAndTitleBasedOnUnreadMessagesCount(
      unreadMessagesCount,
      t("telehealth-core:meta.waitingRoom"),
    );
  }, [t, getActiveConversationSid, getUnreadMessagesCount]);
}
